(() => {
  'use strict';

  const normalize = (v) => String(v || '').toLowerCase().replace(/\s+/g, ' ').trim();
  const CANONICAL = new Map([
    ['home & living', 'Home & Living'], ['kitchen', 'Kitchen'], ['smart living', 'Smart Living'],
    ['pet essentials', 'Pet Essentials'], ['travel', 'Travel'], ['kids & play', 'Kids & Play'],
    ['summer', 'Summer'], ['organization', 'Organization'], ['cleaning', 'Cleaning'], ['gift ideas', 'Gift Ideas']
  ]);

  const inferFromTitle = (text) => {
    const t = normalize(text);
    if (/\bpet planter\b/.test(t)) return 'Smart Living';
    if (/\b(dog|cat|pet)\b.*\b(leash|harness|collar|feeder|bed|groom|brush|toy|ball|water|raincoat|scratching)\b/.test(t) || /\b(leash|harness|collar|pet feeder|cat feeder|dog feeder|cat scratching)\b/.test(t)) return 'Pet Essentials';
    if (/\b(pool|swim|swimming|float|water balloon|water blaster|bubble gun|bubble wand|bubble machine|life jacket|swim vest|swim buoy)\b/.test(t)) return 'Summer';
    if (/\b(travel|luggage|passport|camping|hiking|tent|sleeping bag|hammock|carplay|car charger|car phone|car cup)\b/.test(t)) return 'Travel';
    if (/\b(organizer|storage box|storage rack|storage cabinet|stackable storage)\b/.test(t)) return 'Organization';
    if (/\b(cleaning|cleaner|vacuum|squeegee|duster|scraper|drain)\b/.test(t)) return 'Cleaning';
    if (/\b(kitchen|cookware|juicer|blender|oil sprayer|garlic|chopper|frother|food storage)\b/.test(t)) return 'Kitchen';
    if (/\b(kid|kids|child|children|toddler|baby|toy|puzzle|montessori|busy board|plush|doll|building blocks)\b/.test(t)) return 'Kids & Play';
    if (/\b(smart|led|rgb|lamp|night light|humidifier|diffuser|wireless charger|power bank|sensor|gimbal|bluetooth|water flosser|oral irrigator|solar light)\b/.test(t)) return 'Smart Living';
    if (/\b(manga|anime|wine bottle holder|custom blanket|sculpture)\b/.test(t)) return 'Gift Ideas';
    return 'Home & Living';
  };

  const classify = (card) => {
    if (!card) return '';
    const type = CANONICAL.get(normalize(card.dataset.whProductType));
    if (type) return type;
    return inferFromTitle([card.dataset.whProductTitle, card.dataset.whProductTags, card.dataset.whProductHandle].filter(Boolean).join(' '));
  };

  const addLabel = (card) => {
    if (!card || card.dataset.whCategoryLabelReady === 'true') return;
    const heading = card.querySelector('.card__heading, .wh13-product-card__body h3, .wh67-product-card h3, h3');
    if (!heading) return;
    const label = classify(card);
    const existing = card.querySelector('.wh128-card-category, .wh60-product-category, .wh67-product-card__category');
    if (existing) existing.textContent = label;
    else {
      const node = document.createElement('p');
      node.className = 'wh60-product-category';
      node.textContent = label;
      heading.insertAdjacentElement('afterend', node);
    }
    card.dataset.whCategoryLabelReady = 'true';
  };

  const scan = (scope = document) => scope.querySelectorAll('.card-wrapper, .product-card-wrapper, .wh13-product-card, .wh13-trend-ribbon__card, .wh67-product-card').forEach(addLabel);
  const init = () => {
    scan();
    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) for (const node of mutation.addedNodes) {
        if (!(node instanceof Element)) continue;
        if (node.matches('.card-wrapper, .product-card-wrapper, .wh13-product-card, .wh13-trend-ribbon__card, .wh67-product-card')) addLabel(node);
        scan(node);
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();